import { Divider } from 'antd'
import { PushNotification } from 'src/core/models'
import { CustomTable } from 'src/components'
import React  from 'react'
import { useQuery } from '@tanstack/react-query'
import { PushNotificationsColumns } from 'src/core/table-columns'
import styles from './PushNotificationsPageContent.module.scss'
import { DownOutlined, RightOutlined } from '@ant-design/icons'
import PushNotificationsListHeader from './PushNotificationsListHeader/PushNotificationsListHeader'
import { getAllNotificationsAPI } from 'src/features'

const PushNotificationsPageContent: React.FC = () => {
  const { isLoading, data } = useQuery<PushNotification[]>(['pushNotification'], getAllNotificationsAPI)

  const renderExpandIcon = ({ expanded, onExpand, record }) => {
    const Icon = expanded ? DownOutlined : RightOutlined
    return <Icon onClick={(e) => onExpand(record, e)} className={styles.icon}/>
  }

  const tableProps = {
    loading: isLoading,
    dataSource: data,
    columns: PushNotificationsColumns,
    rowKey: (pushNotification: PushNotification) => pushNotification.id,
    rowClassName: 'fade-animation pointer',
    expandIcon: renderExpandIcon,
  }

  return <>
    {/*Header */}
    <PushNotificationsListHeader
      length={data?.length}
    />
    <Divider/>
    {/* Table */}
    <CustomTable {...tableProps} />
  </>
}

export default PushNotificationsPageContent
